@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=DM+Serif+Display&display=swap');

@font-face {
  font-family: 'Google Sans';
  src: url('https://fonts.cdnfonts.com/s/14880/GoogleSans-Regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Google Sans';
  src: url('https://fonts.cdnfonts.com/s/14880/GoogleSans-Medium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Google Sans';
  src: url('https://fonts.cdnfonts.com/s/14880/GoogleSans-Bold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --font-heading: 'DM Serif Display', serif;
    --font-body: 'DM Sans', sans-serif;
    --font-label: 'DM Sans', sans-serif;

    --background-50: 0.97 0.005 80;
    --background-100: 0.94 0.01 80;
    --background-200: 0.88 0.015 80;
    --background-300: 0.80 0.02 80;
    --background-400: 0.70 0.025 80;
    --background-500: 0.60 0.03 80;
    --background-600: 0.50 0.03 80;
    --background-700: 0.40 0.025 80;
    --background-800: 0.30 0.02 80;
    --background-900: 0.20 0.015 80;
    --background-950: 0.12 0.01 80;

    --foreground-50: 0.97 0.005 30;
    --foreground-100: 0.90 0.01 30;
    --foreground-200: 0.80 0.015 30;
    --foreground-300: 0.70 0.02 30;
    --foreground-400: 0.60 0.025 30;
    --foreground-500: 0.50 0.03 30;
    --foreground-600: 0.40 0.03 30;
    --foreground-700: 0.35 0.025 30;
    --foreground-800: 0.25 0.02 30;
    --foreground-900: 0.18 0.015 30;
    --foreground-950: 0.12 0.01 30;

    --primary-50: 0.95 0.01 30;
    --primary-100: 0.90 0.02 30;
    --primary-200: 0.85 0.03 30;
    --primary-300: 0.75 0.04 30;
    --primary-400: 0.55 0.05 30;
    --primary-500: 0.25 0.02 30;
    --primary-600: 0.20 0.02 30;
    --primary-700: 0.15 0.015 30;
    --primary-800: 0.10 0.01 30;
    --primary-900: 0.08 0.01 30;
    --primary-950: 0.05 0.005 30;

    --accent-50: 0.95 0.03 60;
    --accent-100: 0.90 0.06 60;
    --accent-200: 0.85 0.09 60;
    --accent-300: 0.80 0.12 60;
    --accent-400: 0.70 0.13 60;
    --accent-500: 0.60 0.14 60;
    --accent-600: 0.50 0.13 60;
    --accent-700: 0.40 0.11 60;
    --accent-800: 0.30 0.09 60;
    --accent-900: 0.20 0.06 60;
    --accent-950: 0.12 0.03 60;

    --secondary-50: 0.96 0.015 55;
    --secondary-100: 0.92 0.025 55;
    --secondary-200: 0.85 0.035 55;
    --secondary-300: 0.75 0.04 55;
    --secondary-400: 0.65 0.045 55;
    --secondary-500: 0.55 0.05 55;
    --secondary-600: 0.45 0.045 55;
    --secondary-700: 0.35 0.04 55;
    --secondary-800: 0.25 0.03 55;
    --secondary-900: 0.18 0.025 55;
    --secondary-950: 0.10 0.015 55;
  }
}

@layer components {
  .honeypot-field {
    position: absolute;
    left: -9999px;
    top: -9999px;
    opacity: 0;
    height: 0;
    width: 0;
    overflow: hidden;
    pointer-events: none;
  }
}

html {
  scroll-behavior: smooth;
}

@media (max-width: 767px) {
  html, body {
    overflow-x: hidden;
  }

  /* Make the scrollbar on the services modal cards clearly visible on mobile.
     Color-only (uses existing foreground token); nothing else changes. */
  .mobile-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: oklch(var(--foreground-300)) oklch(var(--background-100) / 0.8);
  }
  .mobile-scrollbar::-webkit-scrollbar {
    width: 7px;
  }
  .mobile-scrollbar::-webkit-scrollbar-track {
    background: oklch(var(--background-100) / 0.8);
  }
  .mobile-scrollbar::-webkit-scrollbar-thumb {
    background: oklch(var(--foreground-300));
    border-radius: 9999px;
  }
  .mobile-scrollbar::-webkit-scrollbar-thumb:hover {
    background: oklch(var(--foreground-400));
  }
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: scale(0.97) translateY(4px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes menuTrayIn {
  from {
    opacity: 0;
    transform: scale(0.92) translateY(-6px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}